// index.tsx (atualizado)
import React from "react";
import Organization from "./Organization";
import Company from "./Company";
import Subsidiary from "./Subsidiary";
import MeiosPagamento from "./MeiosPagamento";
import Site from "./Site";
import Ambients from "./Ambients";
import Items from "./Items";
// As duas telas que existiam e não tinham `case`. Sem ele, a string no menu
// levaria ao "Sessão não encontrada" do `default` — que não quebra, mente em
// silêncio.
import Periodos from "./Periodos";
import LayoutImpressao from "./LayoutImpressao";

interface StoresSectionProps {
  selectedVerticalOption: string;
  isEditing: boolean;
  formData: any;
  decryptedInfoToken: any;
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    field: string
  ) => void;
  // A implementação real é (objectType, payload?) — ver configuration/index.tsx.
  handleSave: (objectType: any, payload?: any) => void;
  updateState: (newState: any) => void;
  handleOpenModal: (type: string, object?: any) => void;
  expandedAccordion: string | null;
  toggleAccordion: (accordionKey: string) => void;
}

const StoresSection: React.FC<StoresSectionProps> = ({
  selectedVerticalOption,
  isEditing,
  formData,
  decryptedInfoToken,
  handleInputChange,
  handleSave,
  updateState,
  handleOpenModal,
  expandedAccordion,
  toggleAccordion,
}) => {
  switch (selectedVerticalOption) {
    case "Empresa":
      return (
        <Organization
          isEditing={isEditing}
          formData={formData}
          decryptedInfoToken={decryptedInfoToken}
          handleInputChange={handleInputChange}
          handleSave={handleSave}
          updateState={updateState}
          expandedAccordion={expandedAccordion}
          toggleAccordion={toggleAccordion}
        />
      );
    case "Estabelecimentos":
      return (
        <Company
          decryptedInfoToken={decryptedInfoToken}
          handleOpenModal={handleOpenModal}
        />
      );
    case "Lojas":
      return (
        <Subsidiary
          decryptedInfoToken={decryptedInfoToken}
          handleOpenModal={handleOpenModal}
        />
      );
    case "Site":
      return <Site decryptedInfoToken={decryptedInfoToken} />;
    case "Meios de Pagamento":
      return <MeiosPagamento decryptedInfoToken={decryptedInfoToken} />;
    case "Ambientes":
      return (
        <Ambients
          decryptedInfoToken={decryptedInfoToken}
          handleOpenModal={handleOpenModal}
        />
      );
    case "Itens":
      return (
        <Items
          decryptedInfoToken={decryptedInfoToken}
          handleOpenModal={handleOpenModal}
        />
      );
    case "Períodos":
      return (
        <Periodos
          decryptedInfoToken={decryptedInfoToken}
          handleOpenModal={handleOpenModal}
        />
      );
    // A mesma tela que a rota /settings/layout-impressao monta. Não é uma
    // cópia: é o mesmo componente, montado nos dois lugares — o precedente
    // exato é o Site, que vive aqui e é envelopado por SitePage.
    case "Layout de Impressão":
      return <LayoutImpressao decryptedInfoToken={decryptedInfoToken} />;
    default:
      return (
        <div
          style={{
            padding: "var(--sp-40)",
            textAlign: "center",
            color: "#6c757d",
          }}
        >
          <div style={{ fontSize: "var(--fs-6xl)", marginBottom: "var(--sp-16)" }}>🔍</div>
          <div style={{ fontSize: "var(--fs-lg)", marginBottom: "var(--sp-8)" }}>
            Sessão não encontrada
          </div>
          <div style={{ fontSize: "var(--fs-md)" }}>{selectedVerticalOption}</div>
        </div>
      );
  }
};

export default StoresSection;
